import { Link } from "react-router-dom";

export default function LegalFooter() {
  return (
    <footer data-testid="legal-footer" className="mt-16 border-t border-zinc-800 pt-6 pb-2">
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
        <div className="text-[10px] font-mono uppercase tracking-widest text-zinc-500">
          © LinguaSub · You are responsible for the rights to what you upload
        </div>
        <div className="flex flex-wrap items-center gap-4 text-[10px] font-mono uppercase tracking-widest">
          <Link data-testid="footer-features" to="/features" className="text-zinc-500 hover:text-white transition-colors">Features</Link>
          <Link data-testid="footer-how" to="/how-it-works" className="text-zinc-500 hover:text-white transition-colors">How it works</Link>
          <Link data-testid="footer-pricing" to="/pricing" className="text-zinc-500 hover:text-white transition-colors">Pricing</Link>
          <Link data-testid="footer-blog" to="/blog" className="text-zinc-500 hover:text-white transition-colors">Blog</Link>
          <Link data-testid="footer-faqs" to="/faqs" className="text-zinc-500 hover:text-white transition-colors">FAQs</Link>
          <Link data-testid="footer-terms" to="/terms" className="text-zinc-500 hover:text-white transition-colors">Terms</Link>
          <Link data-testid="footer-privacy" to="/privacy" className="text-zinc-500 hover:text-white transition-colors">Privacy</Link>
          <Link data-testid="footer-takedown" to="/takedown" className="text-zinc-500 hover:text-white transition-colors">Takedown</Link>
        </div>
      </div>
    </footer>
  );
}
